import { doc, getDoc } from "firebase/firestore";
import { db } from "..";


const findUserName = async (id) => {
    const docRef = doc(db, "userInfo", id)
    const docSnap = await getDoc(docRef);
    let user
    let _success
    if(docSnap.exists()){
        user = {
            fullName: docSnap.data().firstName + " " + docSnap.data().lastName,
            id: docSnap.id
        }
        _success = 200
        return {user, success: _success}
    }
    else {
        return {success: 404}
    }
}

export default findUserName